// The mobile <drawer-menu> binds its own touchstart/touchmove/touchend to a
// swipe-to-close drag. When a mega-menu contains a horizontally scrollable
// media row (e.g. МЪЖЕ image slider), swiping that row bubbles to the drawer
// and closes it. Stop those touches at the scroller so the drawer never starts
// its drag; native horizontal scrolling is unaffected (stopPropagation does not
// cancel default scrolling).
(() => {
  const SCROLLER_SELECTOR = '.drawer-menu__mega-menu-wrapper .mega-menu__block--images';

  const guard = (event) => {
    const target = event.target;
    if (target && target.closest && target.closest(SCROLLER_SELECTOR)) {
      event.stopPropagation();
    }
  };

  for (const type of ['touchstart', 'touchmove', 'touchend']) {
    document.addEventListener(type, guard, { capture: true, passive: true });
  }
})();
